import { Component, Input, OnInit } from "@angular/core";
import { FormSubmissionsService } from "../../services/form-submissions/form-submissions.service";

@Component({
    selector: "app-form",
    templateUrl: "./app-form.component.html",
    styleUrls: ["./app-form.component.scss"]
})
export class AppFormComponent implements OnInit {
    @Input() component: any;

    public formData: any = {};
    public formFields: any[] = [];
    public formTitle: string = "";
    public formDeadline: string = "";
    public isSubmitting = false;
    public hasSubmitted = false;
    public successMessage: string = "";
    public isDeadlinePassed = false;

    constructor(
        private readonly formSubmissionsService: FormSubmissionsService
    ) {}

    ngOnInit() {
        this.initializeForm();
        this.checkExistingSubmission();
    }

    initializeForm() {
        if (this.component?.content) {
            try {
                const formConfig = JSON.parse(this.component.content);

                // Extract form title
                if (formConfig.title) {
                    this.formTitle = formConfig.title;
                }

                // Extract form deadline
                if (formConfig.deadline) {
                    this.formDeadline = formConfig.deadline;
                    this.checkDeadline();
                }

                if (formConfig.successMessage) {
                    this.successMessage = formConfig.successMessage;
                }

                if (formConfig.fields) {
                    this.formFields = formConfig.fields;
                    // Initialize form data with empty values
                    this.formFields.forEach((field) => {
                        if (field.type === "checkbox") {
                            this.formData[field.name] = false;
                        } else if (field.type === "select") {
                            // For select fields, initialize with empty string
                            // The value will be the option name, not the label
                            this.formData[field.name] = "";
                        } else {
                            this.formData[field.name] = "";
                        }
                    });
                }
            } catch (error) {
                console.error("Error parsing form configuration:", error);
            }
        }
    }

    checkDeadline() {
        if (this.formDeadline) {
            const deadlineDate = new Date(this.formDeadline);
            const currentDate = new Date();
            this.isDeadlinePassed = currentDate > deadlineDate;
        }
    }

    checkExistingSubmission() {
        if (this.component?.id) {
            this.formSubmissionsService
                .checkSubmission(this.component.id)
                .subscribe(
                    (response) => {
                        if (response.hasSubmission) {
                            this.hasSubmitted = true;
                            this.formData = response.submission.form_data;
                        }
                    },
                    (error) => {
                        console.error("Error checking submission:", error);
                    }
                );
        }
    }

    onFieldChange(fieldName: string, event: any) {
        if (event.detail) {
            this.formData[fieldName] =
                event.detail.value || event.detail.checked;
        }
    }

    isFormValid(): boolean {
        // Check if deadline has passed
        if (this.isDeadlinePassed) {
            return false;
        }

        // Check required fields
        return this.formFields.every((field) => {
            if (field.required) {
                const value = this.formData[field.name];
                return value !== "" && value !== null && value !== undefined;
            }
            return true;
        });
    }

    submitForm() {
        if (!this.isFormValid() || this.isSubmitting || this.hasSubmitted) {
            return;
        }

        this.isSubmitting = true;

        this.formSubmissionsService
            .submitForm(this.component.id, this.formData)
            .subscribe(
                (response) => {
                    this.hasSubmitted = true;
                    this.isSubmitting = false;
                },
                (error) => {
                    this.isSubmitting = false;
                    console.error("Error submitting form:", error);
                }
            );
    }
}
